<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="term-ya-dialog-header">
      <h2>
        {{termViewModel.label}}
      </h2>
    </div>
    <div class="ya-dialog-content term-ya-dialog-content">
      <div id="termContent" class="term-dialog-content" [innerHtml]="termViewModel.textHtml"></div>
    </div>
  </div>
</div>